<script setup>
import AutocompleteFilter from '@/components/widgets/AutocompleteFilter.vue';
import { inject, onMounted, ref } from 'vue';
import { useInfinite } from '@/composables/use-infinity';

const backendApi = inject('backendApi');

const props = defineProps({
    hideLabel: {
        type: Boolean,
        default: false
    },
    args: {
        type: Object,
        default: null
    }
});

const emit = defineEmits(['update', 'update:focused']);

const selected = ref(null);

const fetchPoBox = ({ pattern, page, limit }) =>
    backendApi().poBox().index({
        pattern,
        active: true,
        page,
        limit
    });

const {
    items: poBox,
    loading: isLoading,
    showRetryButton,
    hasMore,
    searchQuery,
    getItems,
    loadMore,
    reset
} = useInfinite(fetchPoBox);

const handleSearch = () => {
    reset();
    getItems();
};

// Initial data fetch on mount
onMounted(() => {
    getItems();
});
</script>

<template>
    <AutocompleteFilter
        v-model="selected"
        v-model:search="searchQuery"
        :items="poBox"
        item-title="number"
        item-value="id"
        :label="props.hideLabel ? '' : $t('PoBox')"
        :loading="isLoading"
        :show-retry-button="showRetryButton"
        :infinite-scroll="hasMore"
        @infinite-scroll="loadMore"
        @update="emit('update', selected)"
        @preparing-search="handleSearch"
        @search="handleSearch"
        @retry="handleSearch"
        @update:focused="(state) => emit('update:focused', state)"
    >
        <template v-slot:default="{ props, item }">
            <v-list-item
                v-bind="props"
                :title="`${item.raw.customer.fullName}`"
                :subtitle="`${item.raw.number}`"
            ></v-list-item>
        </template>
        <template v-if="$slots.prepend" v-slot:prepend>
            <slot name="prepend"></slot>
        </template>
    </AutocompleteFilter>
</template>
